import React from "react";
import { CheckIcon } from "lucide-react";
import { MockupSlot } from "./MockupSlot";
import { PurchaseButton } from "./PurchaseButton";
import { offerItems } from "../data/landing";
import { offer, productVisuals } from "../data/offer";
export function OfferSection() {
  return <section id="offre" className="bg-terracotta-light" data-id="element-126" data-mp="ddvfle6ywde1">
      <div className="mx-auto max-w-5xl px-4 py-16 md:px-5 md:py-24" data-id="element-127" data-mp="dfg8kzdmvo9s">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-128" data-mp="ic6ptq16cpws">
          Offrez à votre famille de précieux moments de foi.
        </h2>

        <div className="mt-10 overflow-hidden rounded-[2rem] bg-white ring-1 ring-ink/10 md:mt-14 md:grid md:grid-cols-[0.95fr_1.05fr]" data-id="element-129" data-mp="rey3zxlfpzs4">
          <div className="bg-cream p-5 md:p-8" data-id="element-130" data-mp="wawvvv5z1zxa">
            <MockupSlot src={productVisuals.offerMockup} label="Mockup de tout le contenu" className="aspect-square h-full w-full md:aspect-auto md:min-h-[420px]" data-id="element-131" data-mp="2t62u2p7pysac" />
          </div>

          <div className="p-6 md:p-10" data-id="element-132" data-mp="12otffgpb9bih">
            <p className="text-xs font-extrabold tracking-[0.2em] text-sage-deep" data-id="element-133" data-mp="xx1yzyzvcm62">
              OFFRE UNIQUE
            </p>
            <h3 className="mt-2 font-display text-2xl font-bold text-ink md:text-3xl" data-id="element-134" data-mp="syqorn5nw9nb">
              LE MÉGA PACK COMPLET
            </h3>

            <ul className="mt-6 space-y-3" data-id="element-135" data-mp="ou0shx73ct1v">
              {offerItems.map(item => <li key={item} className="flex gap-3 text-ink" data-id="element-136" data-mp="1lll7aeix4yy5">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-light" data-id="element-137" data-mp="1gn1js9ooff3o">
                    <CheckIcon className="h-3.5 w-3.5 text-sage-deep" strokeWidth={3} aria-hidden="true" data-id="element-138" data-mp="1ck4vc2cggort" />
                  </span>
                  <span className="font-semibold leading-snug" data-id="element-139" data-mp="17oxwp8y1ma9r">{item}</span>
                </li>)}
            </ul>

            <hr className="my-7 border-ink/10" data-id="element-140" data-mp="3scawphoac1tm" />

            <div className="text-center" data-id="element-141" data-mp="3sbixzxze5nz4">
              <p className="font-display text-5xl font-bold text-ink md:text-6xl" data-id="element-142" data-mp="3tu99j850tdia">
                {offer.price}
              </p>
              <p className="mt-1 text-sm font-bold uppercase tracking-widest text-ink-soft" data-id="element-143" data-mp="2mn69gm7rd1y">
                Paiement unique
              </p>
            </div>

            <PurchaseButton label="Oui, je veux le Méga Pack" className="mt-6" data-id="element-144" data-mp="3oumuqu9jnp7d" />

            <p className="mt-4 text-center text-xs leading-relaxed text-ink-soft md:text-sm" data-id="element-145" data-mp="3owr9y8cw8amy">
              Format numérique • Fichiers PDF à télécharger et à imprimer •
              Garantie 7 jours
            </p>
          </div>
        </div>
      </div>
    </section>;
}